import React from 'react';
import { FormGroup } from 'reactstrap';
import FloorTreeSelect from './FloorTreeSelect';
import { useSelector } from 'react-redux';
import { useTranslation } from '@hooks';
import { Checkbox, Label, TextInput } from '../../Common';
import Select from '@components/Select';
import SearchableSelect from '@components/Select/SearchableSelect';

export const WidgetName = ({ value, onChange }) => {
    const t = useTranslation('Widget');

    return (
        <Label
            name={t('Widget Name')}
            value={
                <TextInput
                    inputGroupClassName={'w-100'}
                    type={'text'}
                    name={'widgetName'}
                    id={'widgetName'}
                    placeholder={''}
                    value={value}
                    handleChange={e => {
                        const { value } = e.target;
                        onChange(value);
                    }}
                />
            }
        />
    );
};

export const IntervalTime = ({ value, onChange, options }) => {
    const t = useTranslation('Widget');

    return (
        <Label
            name={t('Interval Time')}
            value={
                <Select
                    isModalSelect
                    options={
                        options
                            ? options
                            : [
                                  { value: 10000, label: `10${t('seconds')}` },
                                  { value: 15000, label: `15${t('seconds')}` },
                                  { value: 20000, label: `20${t('seconds')}` },
                                  { value: 30000, label: `30${t('seconds')}` },
                              ]
                    }
                    value={value}
                    onChange={selected => onChange(selected)}
                />
            }
        />
    );
};

export const HiddenHeader = ({ checked, onChange }) => {
    const t = useTranslation('Widget');

    return (
        <Label
            name={t('Hide Header')}
            value={
                <Checkbox
                    id={'hiddenHeader'}
                    handleChecked={e => {
                        const { checked } = e.target;
                        onChange(checked);
                    }}
                    checked={checked}
                />
            }
        />
    );
};

export const ChartType = ({ value, onChange, options }) => {
    const t = useTranslation('CategoryChart');
    const innerValue = { value };

    return (
        <Label
            name={t('Type of Graph')}
            value={
                <Select
                    value={innerValue}
                    options={
                        options
                            ? options
                            : [
                                  { label: t('Pie'), value: 'pie' },
                                  { label: t('Doughnut'), value: 'doughnut' },
                              ]
                    }
                    onChange={selected => onChange(selected)}
                    isModalSelect
                />
            }
        />
    );
};

export const CategoryCode = ({ value, onChange }) => {
    const t = useTranslation('CategoryChart');
    const { topCategoryList } = useSelector(state => state.CategoryInfo);

    return (
        <Label
            name={t('Type of Category')}
            value={
                <Select
                    isModalSelect
                    options={topCategoryList}
                    value={value}
                    onChange={selected => onChange(selected.value)}
                />
            }
        />
    );
};

export const TagState = ({ value, onChange, options }) => {
    const t = useTranslation('TagStateAlarmList');
    return (
        <Label
            name={t('Tag State')}
            value={
                <SearchableSelect
                    title={t('Tag State')}
                    data={
                        options
                            ? options
                            : [
                                  { value: 'sos', label: 'SOS' },
                                  { value: 'battery', label: 'Low Battery' },
                                  { value: 'leaveAlone', label: 'Leave Alone' },
                                  { value: 'longStay', label: 'Long Stay' },
                                  { value: 'lostSignal', label: 'Lost Signal' },
                                  { value: 'fireAlarm', label: 'Fire Alarm' },
                                  { value: 'restriction', label: 'Restriction' },
                              ]
                    }
                    selected={value}
                    onChange={selected => onChange(selected)}
                />
            }
        />
    );
};

export const Floor = ({ defaultValue = '', innerRef }) => {
    const { floorList } = useSelector(state => state.FloorInfo);
    return (
        <FormGroup>
            <Label for="floor">층</Label>
            <FloorTreeSelect floorList={floorList} selectedFloorStr={defaultValue} innerRef={innerRef} />
        </FormGroup>
    );
};

export const SingleFloor = ({ value, onChange }) => {
    const t = useTranslation('GeofenceStatus');
    const { floorList } = useSelector(state => state.FloorInfo);

    return (
        <Label
            name={t('Floor')}
            value={
                <FloorTreeSelect
                    floorList={floorList}
                    selectedFloorStr={value}
                    mode={'radioSelect'}
                    handleChange={selected => onChange(selected)}
                />
            }
        />
    );
};

export const DataInteger = ({ checked, onChange }) => {
    const t = useTranslation('Widget');

    return (
        <Label
            name={t('Change The Y-Axios To an Integer')}
            value={
                <Checkbox
                    id={'dataInteger'}
                    handleChecked={e => {
                        const { checked } = e.target;
                        onChange(checked);
                    }}
                    checked={checked}
                />
            }
        />
    );
};
